import React, { useState } from "react";
import { LucideEye, LucideSave } from "lucide-react";

import Input from "../../../components/dashboard/Input";
import Button from "../../../components/dashboard/Button";
import DesignCenter from "../../../components/dashboard/DesignCenter";
import Properties from "../../../components/dashboard/Properties";
import PhonePreview from "../../../components/dashboard/PhonePreview";

const CreatePSPPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"website" | "onboarding" | "app">(
    "website"
  );

  return (
    <div className="flex bg-gray-50" style={{ height: "calc(100vh - 75px)" }}>
      <DesignCenter />
      <div className="flex-1 flex flex-col">
        <div>
          <div className="bg-white border-b border-gray-200 p-3 flex items-center justify-between gap-3">
            <Input name="psp-name" type="text" placeholder="Enter PSP Name" />

            <div className="flex items-center border border-gray-200 rounded-md bg-gray-100">
              <Button
                variant={activeTab === "website" ? "contained" : "text"}
                size="sm"
                onClick={() => setActiveTab("website")}
                fullWidth
              >
                Website
              </Button>
              <Button
                variant={activeTab === "onboarding" ? "contained" : "text"}
                size="sm"
                onClick={() => setActiveTab("onboarding")}
                fullWidth
              >
                Onboarding
              </Button>
              <Button
                variant={activeTab === "app" ? "contained" : "text"}
                size="sm"
                onClick={() => setActiveTab("app")}
                fullWidth
              >
                App
              </Button>
            </div>

            <div className="flex items-center gap-2">
              <Button variant="outlined" size="sm">
                <div className="flex items-center gap-2">
                  <LucideEye className="w-4 h-4" />
                  <span>Preview</span>
                </div>
              </Button>

              <Button variant="contained" size="sm">
                <div className="flex items-center gap-2">
                  <LucideSave className="w-4 h-4" />
                  <span>Save</span>
                </div>
              </Button>
            </div>
          </div>

          <div className="flex-1 flex items-center justify-center h-full">
            <PhonePreview></PhonePreview>
          </div>
        </div>
      </div>
      <Properties />
    </div>
  );
};

export default CreatePSPPage;
